import React from 'react'
import styles from './Search.module.scss'
import { Input } from 'antd'
import IconSearch from 'assets/icons/icon-search.svg'

const Search = ({ onSearch, size, placeholder, width, value, handleChange }) => {
  const inlineStyle = {
    large: {
      height: '36px',
      width: width || '450px'
    }
  }
  return (
    <div className={styles.searchBox} style={inlineStyle[size]}>
      <Input
        id='searchGroup'
        autoComplete='off'
        size={size} 
        placeholder={placeholder}
        prefix={<img alt = 'IconSearch' src = {IconSearch}/>}
        allowClear
        onPressEnter={onSearch}
        value={value}
        onChange={handleChange}
      />
    </div>
  )
}

export default Search